import { useState } from 'react';
import { forgotPassword } from '../../api/auth';
import Swal from 'sweetalert2';
import { useNavigate, Link } from 'react-router-dom';
import '../../styles/auth.css';

function ForgotPassword() {
  const [emailId, setEmailId] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await forgotPassword({ emailId });
      Swal.fire('OTP Sent', 'Check your email', 'success');
      navigate('/reset-password', { state: { emailId } });
    } catch (err) {
      Swal.fire(
        'Error',
        err.response?.data?.message || 'Failed to send OTP',
        'error'
      );
    }
  };

  return (
    <div className="forgot-container">
      <h2>Forgot Password</h2>

      <p className="forgot-info">
        Enter your registered email. We will send you an OTP to reset your password.
      </p>

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Enter your email"
          value={emailId}
          onChange={(e) => setEmailId(e.target.value)}
          required
        />

        <button type="submit">Send OTP</button>
      </form>

      <p className="redirect-text">
        Remembered your password?{' '}
        <Link to="/login" className="back-login">
          Back to Login
        </Link>
      </p>
    </div>
  );
}

export default ForgotPassword;
